import axiosHttp from "./interceptor.service";

const getTask = ({
  type,
  search,
  project,
  assignedTo,
  assignee,
  month,
  year,
  status,
  priority,
  viewType,
  isBugManager
} = {}) => {
  return axiosHttp.get("/getTodoTask", {
    params: {
      type,
      search,
      project,
      assignedTo,
      assignee,
      month,
      year,
      status,
      priority,
      viewType,
      isBugManager
    },
  });
};

const postTask = (data) => {
  return axiosHttp.post("/lmt/createTaskManagement", data);
};

const updateTask = (id, data) => {
  return axiosHttp.put(`/updateTodoTask/${id}`, data);
};

const getTaskById = ({
  isBugManager,
  project,
  assignedTo,
  search,
  type,
  client,
  assignee,
  month,
  year,
  status,
  priority,
} = {}) => {
  return axiosHttp.get("/lmt/getTaskManagement", {
    params: {
      isBugManager,
      project,
      assignedTo,
      search,
      type,
      client,
      assignee,
      month,
      year,
      status,
      priority,
    },
  });
};

const getTaskSeparateById = (taskId, data) => {
  return axiosHttp.get(`/lmt/getTaskByTaskId/${taskId}`, data);
};

const getClientTaskList = ({
  client,
  project,
  priority,
  search,
  type,
  status,
  month,
  year,
} = {}) => {
  return axiosHttp.get("/lmt/getClientTaskList", {
    params: { client, project, priority, search, type, status, month, year },
  });
};

const getUserProject = (project, data) => {
  return axiosHttp.get(`/lmt/filterProject/${project}`, data);
};

const getProjectBasedUser = (projectId, data) => {
  return axiosHttp.get(`/lmt/getUserProject/${projectId}`, data);
};

const getWorkType = (data) => {
  return axiosHttp.get("/lmt/getWorkType", data);
};

const updateSubtask = (taskId, { subtaskId, subTaskData } = {}) => {
  return axiosHttp.put(`/lmt/updateSubtask/${taskId}`, subTaskData, {
    params: { subtaskId },
  });
};

const deleteTaskFile = (taskId, data) => {
  return axiosHttp.delete(`/lmt/removeFile/${taskId}`, data);
};

const deleteTask = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteTask/${id}`, data);
};

const updateComment = (data) => {
  return axiosHttp.put("/lmt/updateComment", data);
};

const deleteComment = (data) => {
  return axiosHttp.put("/lmt/deleteComment", data);
};

const addReply = (data) => {
  return axiosHttp.put("/lmt/addReply", data);
};
const updateReply = (data) => {
  return axiosHttp.put("/lmt/updateReply", data);
};
const deleteReply = (data) => {
  return axiosHttp.put("lmt/deleteReply", data);
};

const getRelatedBugs = (taskId) => {
  return axiosHttp.get(`/lmt/task/related-bugs/${taskId}`);
};

const getTaskBasicById = (taskId) => {
  return axiosHttp.get(`/getTodoTaskById/${taskId}`);
};

const getTaskHistoryById = (taskId, page = 1, limit = 10) => {
  return axiosHttp.get(`/getTaskHistoryById/${taskId}`, {
    params: { page, limit }
  });
};

const getTaskCommentsById = (taskId, page = 1, limit = 10) => {
  return axiosHttp.get(`/getTaskCommentsById/${taskId}`, {
    params: { page, limit }
  });
};

const getTaskTitleByProject = (projectId) => {
  return axiosHttp.get(`/lmt/task/titlebyProject/${projectId}`);
};

const getAllTimeSheetData = ({
  month,
  year,
  project,
  assignedTo,
  assignee,
  status,
  priority,
  startDate,
  endDate,
  search,
  type,
  page,
  limit,
} = {}) => {
  return axiosHttp.get("/lmt/getTimeSheet", {
    params: {
      month,
      year,
      project,
      assignedTo,
      assignee,
      status,
      priority,
      startDate,
      endDate,
      search,
      type,
      page,
      limit,
    },
  });
};

export {
  postTask,
  getTask,
  updateTask,
  getTaskById,
  getTaskSeparateById,
  getClientTaskList,
  getUserProject,
  getProjectBasedUser,
  getWorkType,
  updateSubtask,
  deleteTaskFile,
  deleteTask,
  updateComment,
  deleteComment,
  addReply,
  updateReply,
  deleteReply,
  getRelatedBugs,
  getTaskBasicById,
  getTaskHistoryById,
  getTaskCommentsById,
  getTaskTitleByProject,
  getAllTimeSheetData,
};
